var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v(" Imagens ")]),_c('InputFileCustom',{model:{value:(_vm.itemData),callback:function ($$v) {_vm.itemData=$$v},expression:"itemData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }